import React from 'react';
import { useTranslation } from 'react-i18next';
import CustomSelect from '../../../Forms/Element/CustomSelect';

const StockStatusSelect = ({ value, onChange, isClearable = true }) => {
    const { t } = useTranslation();

    const options = [
        { value: 'out_of_stock', label: t('out_of_stock') },
        { value: 'low_stock', label: t('low_stock') },
        { value: 'normal_stock', label: t('normal_stock') }
    ];

    return (
        <CustomSelect 
            options={options} 
            value={value} 
            onChange={onChange} 
            isClearable={isClearable} 
            placeholder={t('select')} 
        />
    );
};

export default StockStatusSelect;
